// extracted by mini-css-extract-plugin
export default {"container":"SideBar_container__XBhSl","slideIn":"SideBar_slideIn__G4Lss","close":"SideBar_close__Em4n6","item":"SideBar_item__Y28UZ"};